<h1 class="mat-dialog-title">
  <strong>{{domain.url}}<span class="text-mute"> - ads.txt status</span></strong>
</h1>
<p class="mb-4"
   *ngIf="(domain.adstxtStatus===AdsTxtStatus.NOT_EXIST || domain.adstxtStatus===AdsTxtStatus.NO_RECORDS) && selectedTabIndex === 0">
  Please add our records to your ads.txt file. <br>
  <small>If you have questions please contact us at: <a href="mailto:support@consumable.com">support@consumable.com</a>
  </small>
</p>

<mat-tab-group mat-stretch-tabs [(selectedIndex)]="selectedTabIndex">

  <mat-tab>
    <ng-template mat-tab-label>
      <span matBadge="{{adsTxtDiff.notFound.length}}" matBadgeOverlap="false">Missing</span>
    </ng-template>
    <mat-list class="mat-list--adstxt" *ngIf="missingConsumableRecords.length">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">Consumable</h3>
      <mat-list-item *ngFor="let item of missingConsumableRecords">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3 mb-2"></mat-divider>
    </mat-list>
    <mat-list class="mat-list--adstxt" *ngFor="let dp of missingDps">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">{{dp}}</h3>
      <mat-list-item *ngFor="let item of missingRecordsMap[dp]">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3 mb-2"></mat-divider>
    </mat-list>
    <div class="text-center text-muted p-3" *ngIf="adsTxtDiff.notFound.length === 0">
      <img src="assets/images/file_check.svg" alt="" width="200" class="mb-3"/>
      <p>No missing records</p>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span matBadge="{{adsTxtDiff.recentlyAdded.length}}" matBadgeOverlap="false">Added</span>
    </ng-template>
    <mat-list class="mat-list--adstxt" *ngIf="recentlyAddedConsumableRecords.length">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">Consumable</h3>
      <mat-list-item *ngFor="let item of recentlyAddedConsumableRecords">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3"></mat-divider>
    </mat-list>
    <mat-list class="mat-list--adstxt" *ngFor="let dp of recentlyAddedDps">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">{{dp}}</h3>
      <mat-list-item *ngFor="let item of recentlyAddedRecordsMap[dp]">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3"></mat-divider>
    </mat-list>
    <div class="text-center text-muted p-3" *ngIf="adsTxtDiff.recentlyAdded.length === 0">
      <img src="assets/images/file_check.svg" alt="" width="200" class="mb-3"/>
      <p>No newly added records</p>
    </div>
  </mat-tab>

  <mat-tab>
    <ng-template mat-tab-label>
      <span matBadge="{{adsTxtDiff.recentlyRemoved.length}}" matBadgeOverlap="false">Removed</span>
    </ng-template>
    <mat-list class="mat-list--adstxt" *ngIf="recentlyRemovedConsumableRecords.length">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">Consumable</h3>
      <mat-list-item *ngFor="let item of recentlyRemovedConsumableRecords">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3"></mat-divider>
    </mat-list>
    <mat-list class="mat-list--adstxt" *ngFor="let dp of recentlyRemovedDps">
      <h3 mat-subheader class="bold pb-0 text-gray-dark">{{dp}}</h3>
      <mat-list-item *ngFor="let item of recentlyRemovedRecordsMap[dp]">
        {{item.domain}}, {{item.publisherAccountId}}, {{item.accountType}}
        <span *ngIf="data.showComment" class="px-1">{{item.comment}}</span>
        <span class="ml-2" *ngIf="item.condensed"> (condensed)</span>
      </mat-list-item>
      <mat-divider class="mt-3"></mat-divider>
    </mat-list>
    <div class="text-center text-muted p-3" *ngIf="adsTxtDiff.recentlyRemoved.length === 0">
      <img src="assets/images/file_check.svg" alt="" width="200" class="mb-3"/>
      <p>No removed records</p>
    </div>
  </mat-tab>
</mat-tab-group>


<mat-dialog-actions class="justify-content-center">
  <button mat-raised-button mat-dialog-close>Close</button>
  <button *ngIf="selectedTabIndex === 0" mat-raised-button color="primary" (click)="onCopyToClipboard()"
          class="iconed  mb-3 mb-sm-0">
    <i class="fas fa-clipboard"></i>
    <span>Copy to clipboard</span>
  </button>
</mat-dialog-actions>
